import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as micropython from './micropython';
import * as tios from './tios';
import * as simulator from './simulator';

export default class LogAddNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Add to Event Log';
        this.id = 'node_log_add';
        this.icon = 'HiOutlineTableCells';
        this.linkedFeature = 'log';

        this.inputs = [
            {
                name: 'Log',
                portId: 'add_to_log',
                params: [],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'PAIRS',
                name: 'Event Items',
                settingType: SettingType.ARRAY,
                refId: 'log_key_value',
                required: true,
                default: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDependencies() {
        return ['datetime', 'sntp'];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `##### Print
Prints a string to the console when running in debug mode.

Depending on the **Logging Mode**, this can be printed to the console, the log file, or the LCD.`;
    }
}
